import React, { Component } from "react";
import moment from "moment";
import _ from "lodash";
import { Link } from "react-router-dom";
import { P60Icon, DatePicker, Popup } from "../../components";
import { Text } from "../../components/text";
import {
	COLOUR_RED,
	COLOUR_GREEN,
	COLOUR_TANGERINE,
	COLOUR_BRANDING_LIGHT,
	TEXT_LIGHT,
} from "../../js";
import styles from "./BookingDayView.module.css";

class BookingDayView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			datePickerOpen: false,
		};
	}

	getDateText() {
		return moment(this.props.selectedDate).format("dddd, D MMMM YYYY");
	}

	changeDay = (offset) => {
		const newDate = moment(this.props.selectedDate)
			.add(offset, "day")
			.format("YYYY-MM-DD");
		this.props.changeDay(newDate);
	};

	openDatePicker = () => {
		this.setState({ datePickerOpen: true });
	};

	closeDatePicker = () => {
		this.setState({ datePickerOpen: false });
	};

	selectDate = (date) => {
		this.setState({ datePickerOpen: false });
		this.props.changeDay(date);
	};

	getStatusColor(status) {
		const STATUS_COLORS = {
			Confirmed: COLOUR_GREEN,
			Pending: COLOUR_TANGERINE,
			Rejected: COLOUR_RED,
			Cancelled: COLOUR_RED,
		};
		return STATUS_COLORS[status] || STATUS_COLORS.Confirmed;
	}

	getBookingsForCalendar(calendarId) {
		const dateKey = moment(this.props.selectedDate).format("DD-MM-YYYY");
		return _.sortBy(
			this.props.bookings.filter(
				(b) => b.CalendarId === calendarId && b.DateKey === dateKey,
			),
			(b) => b.RawTime || 0,
		);
	}

	renderBookingCard(booking) {
		const status = booking.Status || "Confirmed";
		return (
			<Link
				className="noUnderline"
				to={`/bookings/booking/${booking.Id}`}
				key={booking.Id}
			>
				<div
					className={styles.card}
					style={{ backgroundColor: COLOUR_BRANDING_LIGHT }}
				>
					<div className={styles.cardTime}>
						{booking.Time}
						{booking.EndTime ? ` - ${booking.EndTime}` : ""}
					</div>
					<div
						className={styles.cardTitle}
						style={booking.IsBlockOut ? { color: COLOUR_RED } : undefined}
					>
						{booking.Title}
					</div>
					{booking.User && booking.User.displayName && (
						<div className={styles.cardUser}>{booking.User.displayName}</div>
					)}
					{booking.BookedBy &&
						booking.BookedBy.displayName &&
						booking.User &&
						booking.BookedBy.displayName !== booking.User.displayName && (
							<div className={styles.cardBookedBy}>
								Booked by: {booking.BookedBy.displayName}
							</div>
						)}
					<div className={styles.cardStatus}>
						<span style={{ color: this.getStatusColor(status) }}>{status}</span>
						{booking.Cancelled && (
							<span style={{ color: COLOUR_RED, marginLeft: 8 }}>
								(Cancelled)
							</span>
						)}
					</div>
				</div>
			</Link>
		);
	}

	renderCalendarColumn(calendar) {
		const bookings = this.getBookingsForCalendar(calendar.Id);
		return (
			<div className={styles.column} key={calendar.Id}>
				<div className={styles.columnHeader}>
					<Text type="h5">{calendar.Title}</Text>
					<Text type="body" style={{ color: TEXT_LIGHT, marginTop: 2 }}>
						{bookings.length} booking{bookings.length !== 1 ? "s" : ""}
					</Text>
				</div>
				<div className={styles.columnBody}>
					{bookings.length === 0 && (
						<div className={styles.empty}>
							<Text type="body" style={{ color: TEXT_LIGHT }}>
								No bookings
							</Text>
						</div>
					)}
					{bookings.map((booking) => this.renderBookingCard(booking))}
				</div>
			</div>
		);
	}

	renderDatePicker() {
		if (!this.state.datePickerOpen) {
			return null;
		}
		return (
			<Popup
				title="Select Date"
				maxWidth={400}
				minWidth={340}
				hasPadding
				onClose={this.closeDatePicker}
			>
				<DatePicker
					hideTop
					selectedDate={this.props.selectedDate}
					selectDate={this.selectDate}
				/>
			</Popup>
		);
	}

	render() {
		const calendars = this.props.calendars || [];

		return (
			<div className={styles.container}>
				{this.renderDatePicker()}
				<div className="eventCalendar__monthSelector">
					<P60Icon
						className="eventCalendar__monthChevron"
						icon="chevron_left"
						onClick={() => this.changeDay(-1)}
					/>
					<p
						className="eventCalendar__selectedMonth"
						style={{ minWidth: 220, cursor: "pointer" }}
						onClick={this.openDatePicker}
					>
						{this.getDateText()}
					</p>
					<P60Icon
						className="eventCalendar__monthChevron"
						icon="chevron_right"
						onClick={() => this.changeDay(1)}
					/>
				</div>
				{this.props.loading && (
					<div className={styles.loading}>
						<Text type="body" style={{ color: TEXT_LIGHT }}>
							Loading bookings...
						</Text>
					</div>
				)}
				{!this.props.loading && calendars.length === 0 && (
					<div className={styles.loading}>
						<Text type="body" style={{ color: TEXT_LIGHT }}>
							No calendars available
						</Text>
					</div>
				)}
				{!this.props.loading && calendars.length > 0 && (
					<div className={styles.columns}>
						{calendars.map((calendar) => this.renderCalendarColumn(calendar))}
					</div>
				)}
			</div>
		);
	}
}

export default BookingDayView;
